import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import recurssion from './recurrence.json';
import { actions } from 'react-table';
const day = moment().format('dddd').substring(0, 2).toLocaleUpperCase();
const month = moment().format('M');
const schedulerDate = moment().format("YYYY-MM-DD")


const initialState = {
  loadingFlag: 0,
  selectedOption: {
    newPost: false,
    fromTemplate: false,
    createTemplate: false,
    editJobPost: false,
  },
  masterData: {
    jobID: '',
    navigateMatchingCandidate: false,
    matchingJobid: '',
    allJobDomains: [],
    allJobTypes: [],
    startJobPost: [
      { id: 1, name: 'Start with a new post' },
      { id: 2, name: 'Choose from job templates' },
    ],
    allTemplates: [],
    allJobLocations: [],
    allJobLocationContactPersons: [],
    allJobLocationApprovers: [],
    calendarJobLocationContactPersons: [],
    calendarobLocationApprovers: [],
    allShiftStartTime: [],
    allShiftEndTime: [],
    allPreferedShifts: [],
    allJobCategory: [],
    allEducationLevels: [],
    allMedicalSpecialities: [],
    allCertifications: [],
    allEmrEhrSystemExperience: [],
    allCovidVaccinatedOption: [],
    allTemplateInfo: [
      { id: 0, name: "Don't save as template" },
      { id: 1, name: 'Save as new Template' },
    ],
    createTemplateInfo: [{ id: 1, name: 'Save as new Template' }],
    fromTemplateInfo: [
      { id: 1, name: 'Save as new Template' },
      { id: 2, name: 'Overwrite template' },
    ],
    maxContactPersons: 3,
    maxApprovalUsers: 3,
    daysData: recurssion.days,
    monthsData: recurssion.months,
    repeatData: recurssion.repeat,
    startbyData: recurssion.startby,
  },
  jobType: {
    domain: '',
    type: {},
  },
  startJob: {
    templateID: '',
  },
  location: {
    locationNameInfo: undefined,
    contactPersons: [],
    approvalUsers: [],
    address: {},
  },
  shift: {
    startTime: undefined,
    endTime: undefined,
    preferedShift: undefined,
    date: '',
    endDate: '',
    fullFormatDate: '',
    singleShiftEndDate:''
  },
  jobInfo: {
    jobTemplate: {
      name: 'Select',
    },
    jobCategory: undefined,
    jobTitle: undefined,
    jobDescription: '',
    ratePerHour: 0,
    shiftamount: 0,
    billingrate: 0,
    billingRateParam: 0,
    restoreBillingrate: 0,
    incentive: '',
    total: 0,
    mileage: [],
    payRates: []
  },
  education: {
    level: undefined,
    languageSpoken: [],
    otherLanguagesSpoken: [],
  },
  medicalSpeciality: {
    speciality: [],
    otherSpeciality: [
      {
        name: '',
        yearsOfExperience: 0,
      },
    ],
  },
  certification: {
    definedCertification: [],
    otherCertification: [
      {
        name: '',
        mandatory: false,
      },
    ],
  },
  emrEhrSystemExperience: {
    definedExperience: [],
    otherExperience: [
      {
        name: '',
        mandatory: false,
      },
    ],
  },
  covidVaccinationStatus: [],
  templateInfo: {
    option: 0,
    name: '',
  },
  jobSaveError: '',
  errors: {},
  errorLogs: [],
  loadJobId: undefined,
  dropDownJobId: 0,
  formdata: [],
  distance: '',
  recursionFlag: '1',
  repeatEvery: {
    on: '1',
    // type: 'DAILY',
    type: 'WEEKLY',
  },
  byWeeks: [day],
  byMonths: {
    checkedBy: 'onthe',
    onDay: '1',
    onthe: {
      position: '1',
      day: day,
    },
  },
  byYear: {
    checkedBy: 'on',
    on: {
      position: '1',
      month: month,
    },
    onthe: {
      position: '1',
      day: day,
      month: month,
    },
  },
  rrurle: '',
  rrurleStr: '',
  jobMultishiftOccurreneUpdateList: [],
  JobEncounterOccurreneUpdateList: [],
  displayContactApprovererror: false,
  resetDropdown: false,
  jobUnique: '',
  jobCode: '',
  editJobUniqueId: '',
  appointmentData: [],
  shiftLengthData: [],
  approvedcandidates: [],
  jobShiftAmountMultishiftOccurreneUpdateList: [],
  authUsersList: [],
  selectedAuthUsers: [],
  grouping: {
    group: [],
    resources: []
  },
  encounterCalculation: [],
  currentSchedularDate: schedulerDate,
  showCalenderModal: false,
  editDayDate: [],
  incentiveMarkup: 0,
  isAutoPostAllowed: null,
  checkMarkup: [],
  isOvertimeAllowed: null,
  depsUnits: [],
  showDailyCalendar:false,
  payRateType:null,
  payRateTotalShiftAmount:null,
  payRateOccurrenceAmount:null
};

export const jobOpportunity = createSlice({
  name: 'jobOpportunity',
  initialState,
  reducers: {
    setMasterData: (state, action) => {
      state.masterData['allJobDomains'] = action.payload?.jobDomains;
      state.masterData['allJobTypes'] = action.payload?.jobTypes;
      state.masterData['allJobLocations'] = action.payload?.jobLocations;
      state.masterData['allTemplates'] =
        action.payload?.jobTemplates?.templateList;
      state.masterData['allShiftStartTime'] = action.payload?.shiftStartTime;
      state.masterData['allShiftEndTime'] = action.payload?.shiftEndTime;
      state.masterData['allPreferedShifts'] = action.payload?.shiftPreferedTime;
      state.masterData['allSpokenLanguages'] = action.payload?.spokenLanguages;
      // state.masterData['allEducationLevels'] = action.payload?.educationLevels;
      // state.masterData['allCertifications'] = action.payload?.certifications;
      // state.masterData['allEmrEhrSystemExperience'] = action.payload?.emrEhrSystemExp;
      // state.masterData['allMedicalSpecialities'] = action.payload?.specialities;
      state.masterData['allCovidVaccinatedOption'] =
        action.payload?.covidVaccinationOptions;
    },
    updateJobemrEhrSystemExpMasterData: (state, action) => {
      state.masterData['allEmrEhrSystemExperience'] = action.payload;
    },

    updateJobcertificationsMasterData: (state, action) => {
      state.masterData['allCertifications'] = action.payload;
    },
    updateJobspecialitiesMasterData: (state, action) => {
      state.masterData['allMedicalSpecialities'] = action.payload;
    },
    updateLocationContactsInMasterData: (state, action) => {
      state.masterData['allJobLocationContactPersons'] =
        action.payload.contacts;
      state.masterData['allJobLocationApprovers'] = action.payload.approvers;
    },
    updateCalendarLocationDetail: (state, action) => {
      state.masterData['calendarJobLocationContactPersons'] =
        action.payload.contacts;
      state.masterData['calendarobLocationApprovers'] = action.payload.approvers;
    },
    updateJobCategoryMasterData: (state, action) => {
      state.masterData['allJobCategory'] = action.payload;
    },
    updateEducationLevelMasterData: (state, action) => {
      state.masterData['allEducationLevels'] = action.payload;
    },
    updateJobOpportunityFailed: (state, action) => {
      state['errorMessage'] = action.payload;
    },
    updateJobTypeDetails: (state, action) => {
      state.jobType[action.payload.field] = action.payload.data;
    },
    updateStartJobDetails: (state, action) => {
      state.startJob[action.payload.field] = action.payload.data;
    },
    updateLocationAddress: (state, action) => {
      state.location.address = action.payload;
    },
    updateLocationDetails: (state, action) => {
      state.location[action.payload.field] = action.payload.data;
    },
    addLocationContactPerson: (state, action) => {
      const newFields = [...state.location.contactPersons, action.payload];
      state.location.contactPersons = newFields;
    },
    removeLocationContactPerson: (state, action) => {
      const newFields = state.location.contactPersons.filter(
        (person) => person.id !== action.payload.id
      );
      state.location.contactPersons = newFields;
    },
    addLocationApprover: (state, action) => {
      const newFields = [...state.location.approvalUsers, action.payload];
      state.location.approvalUsers = newFields;
    },
    removeLocationApprover: (state, action) => {
      const newFields = state.location.approvalUsers.filter(
        (person) => person.id !== action.payload.id
      );
      state.location.approvalUsers = newFields;
    },
    clearContactAndApprovalUser: (state) => {
      state.location.contactPersons = [];
      state.location.approvalUsers = [];
    },
    updateShiftDetails: (state, action) => {
      state.shift[action.payload.field] = action.payload.data;
    },
    updateJobInfo: (state, action) => {
      state.jobInfo[action.payload.field] = action.payload.data;
    },
    updateJobDescription: (state, action) => {
      state.jobInfo['jobDescription'] = action.payload;
    },
    updateEducationInfo: (state, action) => {
      state.education = action.payload;
    },

    updateMedicalSpecialityInfo: (state, action) => {
      state.medicalSpeciality = action.payload;
    },

    updateCertificationInfo: (state, action) => {
      state.certification = action.payload;
    },

    updateEMREHRSystemExpInfo: (state, action) => {
      state.emrEhrSystemExperience = action.payload;
    },

    updateCovidInfo: (state, action) => {
      state.covidVaccinationStatus = action.payload;
    },

    updateTemplateInfo: (state, action) => {
      state.templateInfo[action.payload.name] = action.payload.value;
    },

    updateErrors: (state, action) => {
      state.errors = action.payload;
    },

    updateJobSaveAPIErrors: (state, action) => {
      state.jobSaveError = action.payload;
    },

    resetJobOpportunity: (state) => {
      const newVal = JSON.parse(JSON.stringify(state.formdata));
      newVal.forEach((item) => {
        item.controlsInfo.forEach((val) => {
          val.selectedValueOptions = [];
        });
      });
      const data = {
        ...state.masterData,
        allJobLocationContactPersons: [],
        allJobLocationApprovers: [],
        calendarJobLocationContactPersons: [],
        calendarobLocationApprovers: [],
      };

      return {
        ...initialState,
        masterData: data,
        formdata: newVal,
        appointmentData: state.appointmentData,
        shiftLengthData: state.shiftLengthData,
        approvedcandidates: state.approvedcandidates,
        isAutoPostAllowed: false,
        selectedOption:state.selectedOption
        
      };
    },
    setFailureLogs: (state, action) => {
      const errorLogs = [...state.errorLogs, action.payload];
      state.errorLogs = errorLogs;
    },

    reviewValidateSubmit: (state, action) => { },
    loadDataForEdit: (state, action) => {
      const keys = Object.keys(action.payload);
      keys.forEach((key) => {
        state[key] = action.payload[key];
      });
    },
    loadJobId: (state, action) => {
      state.loadJobId = action.payload;
    },
    setMatchingCandidateData: (state, action) => {
      state.matchingJobid = action.payload.matchingJobID;
      state.navigateMatchingCandidate = action.payload.navigate;
      state.editJobUniqueId = action.payload.editJobUniqueId;
    },
    setSelectedOption: (state, action) => {
      console.log({payload:action.payload});
      state.selectedOption = action.payload;
      if (action.payload.createTemplate) {
        state.templateInfo.option = 1;
      }
    },
    removecovidVaccination: (state, action) => {
      const newFields = state.covidVaccinationStatus.filter(
        (person) => person.id !== action.payload.id
      );
      state.covidVaccinationStatus = newFields;
    },
    addcovidVaccination: (state, action) => {
      const newFields = [...state.covidVaccinationStatus, action.payload];
      state.covidVaccinationStatus = newFields;
    },
    setDropdownJobId: (state, action) => {
      state.dropDownJobId = action.payload;
    },
    setFormData: (state, action) => {
      state.formdata = action.payload;
    },
    setDistance: (state, action) => {
      state.distance = action.payload;
    },
    setreursionFlag: (state, action) => {
      state.recursionFlag = action.payload;
    },
    setrepeatEvery: (state, action) => {
      if (action.payload?.field === 'on' && !action.payload.fullData) {
        state.repeatEvery.on = action.payload.data;
      } else if (action.payload?.field === 'type' && !action.payload.fullData) {
        state.repeatEvery.type = action.payload.data;
      } else if (action.payload.fullData) {
        state.repeatEvery = action.payload.data;
      }
    },
    setWeeks: (state, action) => {
      state.byWeeks = action.payload;
    },
    setMonth: (state, action) => {
      state.byMonths.checkedBy = action.payload.type;
      if (action.payload.type === 'onday') {
        state.byMonths.onDay = action.payload.data;
      } else if (action.payload.type === 'onthe') {
        if (
          action.payload?.data &&
          action.payload?.field &&
          !action.payload.fullData
        ) {
          state.byMonths.onthe[action.payload.field] = action.payload.data;
        } else if (action.payload?.data && action.payload.fullData) {
          state.byMonths.onthe = action.payload.data;
        }
      }
    },
    setYear: (state, action) => {
      state.byYear.checkedBy = action.payload.type;
      if (action.payload.type === 'on') {
        if (action.payload?.field && !action.payload.fullData) {
          state.byYear.on[action.payload.field] = action.payload.data;
        } else if (action.payload?.data && action.payload.fullData) {
          state.byYear.on = action.payload.data;
        }
      } else if (action.payload.type === 'onthe') {
        if (
          action.payload?.data &&
          action.payload?.field &&
          !action.payload.fullData
        ) {
          state.byYear.onthe[action.payload.field] = action.payload.data;
        } else if (action.payload?.data && action.payload.fullData) {
          state.byYear.onthe = action.payload.data;
        }
      }
    },
    setrrule: (state, action) => {
      state.jobShiftAmountMultishiftOccurreneUpdateList = []
      state.jobMultishiftOccurreneUpdateList = []
      state.jobInfo.billingrate = initialState?.jobInfo?.billingrate;
      state.rrurle = action.payload;
    },
    setrruleStr: (state, action) => {
      state.rrurleStr = action.payload;
    },
    setjobMultishiftOccurreneUpdateList: (state, action) => {
      state.jobMultishiftOccurreneUpdateList = action.payload;
    },
    setDisplayContactApprovererror: (state, payload) => {
      state.displayContactApprovererror = payload;
    },
    setResetDropdown: (state, action) => {
      state.resetDropdown = action.payload;
    },
    setLoadingFlagIncrement: (state) => {
      state.loadingFlag = state.loadingFlag + 1;
    },
    setLoadingFlagDecrement: (state) => {
      if (state.loadingFlag !== 0) {
        state.loadingFlag = state.loadingFlag - 1;
      }
    },
    setJobEncounterOccurreneUpdateList: (state, action) => {
      state.JobEncounterOccurreneUpdateList = action.payload;
    },
    setCalenderData: (state, action) => {
      state.appointmentData = action.payload.appointmentData;
      state.shiftLengthData = action.payload.shiftLengthData;
      state.approvedcandidates = action.payload.approvedcandidates;
    },
    setJobShiftAmountMultishiftOccurreneUpdateList: (state, action) => {
      state.jobShiftAmountMultishiftOccurreneUpdateList = action.payload;
    },
    setAuthUsers: (state, action) => {
      state.authUsersList = action.payload
    },
    setSelectedAuthUsers: (state, action) => {
      state.selectedAuthUsers = action.payload
    },
    setGrouping: (state, action) => {
      state.grouping[action.payload.key] = action.payload.value
    },
    setencounterCalculation: (state, action) => {
      state.encounterCalculation = action.payload
    },
    setCurrentSchedularDate: (state, action) => {
      state.currentSchedularDate = action.payload;
    },
    resetShiftAmount: state => {
      state.jobInfo.billingrate = initialState?.jobInfo?.billingrate;
      state.jobInfo.billingRateParam = initialState?.jobInfo?.billingRateParam;
      state.jobInfo.shiftamount = initialState?.jobInfo?.shiftamount;
      state.jobInfo.total = initialState?.jobInfo?.total;
    },
    setShowCalenderModal: (state, action) => {
      state.showCalenderModal = action.payload;
    },
    updateEditDayDate: (state, action) => {
      state.editDayDate = action.payload;
    },
    setIncentiveMarkup: (state, action) => {
      state.incentiveMarkup = action.payload.incentiveMarkup;
    },
    updateLocationList: (state, action) => {
      state.location[action.payload.field] = action.payload.updateUserList
    },
    setAutoRepost: (state, action) => {
      state.isAutoPostAllowed = action.payload
    },
    setchekMarkup: (state, action) => {
      state.checkMarkup = action.payload
    },
    setOvertimeAllowed: (state, action) => {
      state.isOvertimeAllowed = action.payload;
    },
    setCreationValue: (state, action) => {
      const { field, value } = action.payload;
      state.depsUnits = value;
    },
    setShowDailyCalendar:(state,{payload}) => {
      state.showDailyCalendar = payload;
    },
    setPayRateType:(state,{payload:{name,value}}) => {
      state[name] = value;
    },
    updateSingleShiftEndDate:(state,{payload}) => {
      state.shift.singleShiftEndDate = payload;
    }
  },
});

export const {
  setMasterData,
  updateStartJobDetails,
  updateLocationDetails,
  addLocationContactPerson,
  removeLocationContactPerson,
  addLocationApprover,
  removeLocationApprover,
  updateJobTypeDetails,
  updateLocationContactsInMasterData,
  updateShiftDetails,
  updateJobInfo,
  updateJobCategoryMasterData,
  updateLocationAddress,
  updateEducationInfo,
  updateCertificationInfo,
  updateMedicalSpecialityInfo,
  updateEducationLevelMasterData,
  updateEMREHRSystemExpInfo,
  updateCovidInfo,
  updateTemplateInfo,
  updateJobSaveAPIErrors,
  updateErrors,
  setFailureLogs,
  resetJobOpportunity,
  updateJobDescription,
  loadDataForEdit,
  loadJobId,
  setMatchingCandidateData,
  setSelectedOption,
  clearContactAndApprovalUser,
  removecovidVaccination,
  addcovidVaccination,
  updateJobspecialitiesMasterData,
  updateJobcertificationsMasterData,
  updateJobemrEhrSystemExpMasterData,
  setDropdownJobId,
  setFormData,
  setDistance,
  setreursionFlag,
  setrepeatEvery,
  setWeeks,
  setMonth,
  setYear,
  setrrule,
  setrruleStr,
  setjobMultishiftOccurreneUpdateList,
  setDisplayContactApprovererror,
  setResetDropdown,
  setLoadingFlagIncrement,
  setLoadingFlagDecrement,
  setJobEncounterOccurreneUpdateList,
  setCalenderData,
  setJobShiftAmountMultishiftOccurreneUpdateList,
  setAuthUsers,
  setSelectedAuthUsers,
  setGrouping,
  setencounterCalculation,
  setCurrentSchedularDate,
  resetShiftAmount,
  updateCalendarLocationDetail,
  setShowCalenderModal,
  updateEditDayDate,
  setIncentiveMarkup,
  updateLocationList,
  setAutoRepost,
  setchekMarkup,
  setOvertimeAllowed,
  setCreationValue,
  setShowDailyCalendar,
  setPayRateType,
  updateSingleShiftEndDate
} = jobOpportunity.actions;

export default jobOpportunity.reducer;
